import React, { useEffect } from 'react';
import {
	formatDateWithDayOfTheWeek,
	formatDate,
	formatTime
} from '../utils/util';
import { GQLCreateEntryMutation, GQLTestType } from '../generated/graphql';
import { acquisitionFormLabel, chueiBankMemberTypeLabel, kyofukuMemberTypeLabel, sexLabel, testTypeLabel } from '../constants/label';
import { TestPlacesProps } from '../entry-points/entry';
import { typeLabel } from '../../../api/src/enms/type';

export function Complete({ res: entry }: { res: GQLCreateEntryMutation['createEntry']; } & TestPlacesProps) {
	const testDate = entry.testDate;
	const testPlace = testDate.testPlace;
	return <>
		<h3 className="complete-title">申し込み完了</h3>
		<dl>
			<dt>申し込みID</dt>
			<dd>{entry.id.padStart(8, '0')}</dd>
		</dl>
		<dl>
			<dt>コース</dt>
			<dd>
				{testTypeLabel[entry.testType]}
			</dd>
		</dl>
		<dl>
			<dt>検査項目</dt>
			<dd>{typeLabel[entry.type]}</dd>
		</dl>
		{testPlace.acceptAntiCovid19Test && <dl>
			<dt>新型コロナウィルス抗体検査</dt>
			<dd>{entry.antiCovid19Test ? '希望する' : '希望しない'}</dd>
		</dl>}
		{entry.testType !== GQLTestType.Kyofuku && <>
			<dl>
				<dt>検査会場</dt>
				<dd>{testPlace.name}</dd>
			</dl>
		</>}
		{testDate && <>
			<dl>
				<dt>検査日</dt>
				<dd>{formatDateWithDayOfTheWeek(new Date(testDate.startDate))}</dd>
			</dl>
			<dl>
				<dt>検査時間</dt>
				<dd>{formatTime(new Date(testDate.startDate))} - {formatTime(new Date(testDate.endDate))}</dd>
			</dl>
		</>}
		<dl>
			<dt>支払い</dt>
			<dd>{entry.testType === GQLTestType.StandardFreeLp ? '現地決済' : 'コンビニ払い'}</dd>
		</dl>
		{entry.testType === GQLTestType.Kyofuku && <>
			<dl>
				<dt>神奈川県教育福祉振興会会員タイプ</dt>
				<dd>
					{entry.kyofukuMemberType ?
						kyofukuMemberTypeLabel[entry.kyofukuMemberType] :
						'なし'}
				</dd>
			</dl>
			<dl>
				<dt>神奈川県教育福祉振興会会員ID</dt>
				<dd>{entry.kyofukuMemberId}</dd>
			</dl>
		</>}
		{entry.testType === GQLTestType.ChueiBank && <>
			<dl>
				<dt>中栄信用金庫 会員タイプ</dt>
				<dd>
					{entry.chueiBankMemberType ?
						chueiBankMemberTypeLabel[entry.chueiBankMemberType] :
						'なし'}
				</dd>
			</dl>
		</>}
		<dl>
			<dt>郵便番号</dt>
			<dd>{entry.zipcode}</dd>
		</dl>
		<dl>
			<dt>住所1</dt>
			<dd>{entry.address1}</dd>
		</dl>
		<dl>
			<dt>住所2</dt>
			<dd>{entry.address2}</dd>
		</dl>
		<dl>
			<dt>電話番号</dt>
			<dd>{entry.phoneNumber}</dd>
		</dl>
		<dl>
			<dt>メールアドレス</dt>
			<dd>{entry.email}</dd>
		</dl>
		<dl>
			<dt>氏名</dt>
			<dd>{entry.lastName} {entry.firstName}</dd>
		</dl>
		<dl>
			<dt>氏名(フリガナ)</dt>
			<dd>{entry.lastNameKana} {entry.firstNameKana}</dd>
		</dl>
		<dl>
			<dt>性別</dt>
			<dd>{sexLabel[entry.sex]}</dd>
		</dl>
		<dl>
			<dt>生年月日</dt>
			<dd>{formatDate(entry.birthday)}</dd>
		</dl>
		<dl>
			<dt>以前にMetallo-balance検査を受けたことがある</dt>
			<dd>{entry.hasEntryBefore ? 'はい' : 'いいえ'}</dd>
		</dl>
		{entry.groupCode &&
			<dl>
				<dt>グループコード</dt>
				<dd>{entry.groupCode}</dd>
			</dl>}
		{entry.serviceCode &&
			<dl>
				<dt>サービスコード</dt>
				<dd>{entry.serviceCode}</dd>
			</dl>}
		{entry.introducerId &&
			<dl>
				<dt>法人ID</dt>
				<dd>{entry.introducerId}</dd>
			</dl>}
		{entry.hasEntryBefore || <>
			<dl>
				<dt>どこでメタロ・バランスを知りましたか</dt>
				<dd>{entry.acquisitionFrom ? acquisitionFormLabel[entry.acquisitionFrom] : 'なし'}</dd>
			</dl>
			{entry.acquisitionFromAdMedia && <dl>
				<dt>雑誌・新聞・広告などの名称</dt>
				<dd>{entry.acquisitionFromAdMedia}</dd>
			</dl>}
		</>}
		<p className="complete-note">ご希望日時の変更またはキャンセル、お問い合わせの際は申し込みIDをお伝えいただけるとスムーズです。</p>
		<p className="complete-note red">お申し込み後、株式会社レナテックより検査必要書類をご登録いただいたご住所宛に送付いたしますが、その時期は検査日の1ヶ月前〜1週間前迄に順次行わさせていただきます。検査日の1週間前をすぎても書類が届かない場合は申し訳ありませんが、0120-785-602までお問い合わせください。</p>
		<div className="continue-entry-button-container">
			<a href="/entry" className="button" onClick={e => {
				e.preventDefault();
				location.reload();
			}}>続けて申し込む</a>
		</div>
	</>;
}
